module.exports = __webpack_public_path__ + "img/pdf-file.3d3c5429.svg";